import React from "react";
import { ReactComponent as CheckmarkIcon } from "../../assets/Icons/Check.svg"; // Import SVG as React component

const Checkbox = ({
  checked,
  onChange,
  value,
  label,
  disabled,
  className,
  containerStyle,
  name
}) => {
  return (
    <label className={`flex items-center cursor-pointer ${className}`}>
      <div
        className={`flex items-center justify-center w-[20px] h-[20px] border-[2px] border-blue-shades rounded-[2px] relative ${containerStyle} ${
          checked ? "bg-white" : "bg-white"
        } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      >
        <input
          type="checkbox"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="appearance-none w-full h-full opacity-0" // Hide default checkbox
        />
        {checked && (
          <div className="absolute inset-0 flex items-center justify-center">
            <CheckmarkIcon
              className="w-[20px] h-[20px] text-gray"
              style={{
                marginLeft: "0.6px",
                marginRight: "1px",
                marginTop: "1.5px",
                marginBottom: "1.5px",
              }}
            />
          </div>
        )}
      </div>
      <span className="ml-[8px] text-gray text-level-4 font-inter font-regular items-center">
        {label}
      </span>
    </label>
  );
};

export default Checkbox;
